require('./RAAssociateObjectiveView.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const moment = require('moment');
const classNames = require('classnames');

// @assets
const carImage = require('../../assets/icons/coche.png');
const travelImage = require('../../assets/icons/viaje.png');
const homeImage = require('../../assets/icons/casa.png');
const educationImage = require('../../assets/icons/educacion.png');
const otherImage = require('../../assets/icons/otro.png');

// @commons
const { AmountInput } = require('commonsComponents/amountInput');
const BrokerEditAlias = require('components/commons/broker/brokerEditAlias/brokerEditAlias');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKDatePicker } = require('commonsComponents/OKDatePicker');
const RAContributionPeriodicity = require('../../components/RAContributionPeriodicity/RAContributionPeriodicity');
const RACover = require('../../components/commons/RACover/RACover');
const { OKMessage } = require('commonsComponents/OKMessage');
const {
    SignaturePattern,
} = require('components/signaturePattern/signaturePattern');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const RACgdNumber = require('../../components/RACgdNumber/RACgdNumber');
const RAImageButton = require('../../components/commons/RAImageButton/RAImageButton');
const RAImageButtonGroup = require('../../components/commons/RAImageButtonGroup/RAImageButtonGroup');
const RAStrategiesGraph = require('../../components/RAStrategiesGraph/RAStrategiesGraph');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const RAFooter = require('../../components/commons/RAFooter/RAFooter');
const RAAssociateObjectiveSuccess = require('./RAAssociateObjectiveSuccess/RAAssociateObjectiveSuccess');
const RATimeHorizonCheck = require('../../components/RATimeHorizonCheck/RATimeHorizonCheck');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const {
    PrinterPreviewManager,
} = require('components/contactCenter/printer/printerPreviewManager');

// @actions
const raAccountDetailsActions = require('../../actions/RAAccountDetails');
const brokerMyInvestments = require('actions/brokerMyInvestments');
const expectedProfitabilityActions = require('../../actions/RAExpectedProfitability');
const raSetGoalActions = require('../../actions/RASetGoal');
const raTimeHorizonCheckActions = require('../../actions/RATimeHorizonCheck');
const raAssociateObjectiveActions = require('../../actions/RAAssociateObjective');
const raCustomPlanByObjectiveActions = require('../../actions/RACustomPlanByObjective');

// @utilities
const {
    formatText,
    FormattedText,
    getLanguage,
    hasTranslation,
} = require('core/i18n').i18n;
const {
    buildAccountsDropdownOptions,
} = require('../../utilities/RAAccountsHelper');
const {
    getDay,
    getNumOfDaysBetweenDates,
    getFullYear,
    getMonthNameFromDate,
} = require('utilities/dateHelper');
const { toFirstUppercase } = require('utilities/stringHelper');
const CurrencyHelper = require('utilities/currencyHelper');
const { recordLink } = require('utilities/tagging');

// @constants
const {
    BROKER_PG_URL,
    BROKER_ROBO_EDIT_FIELD_FONT,
    BROKER_STOCKS_CONTRACT_DROPDOWN_DERIVATIVES_TRANSFER_MODIFIER,
    DATE_FORMAT_API,
    EURO_SYMBOL,
    FIRST_STEP,
    EURO_TEXT,
    API_ENTERPRISE_NUMBER,
    API_CENTER,
} = require('constants/index');

const {
    GO_BACK_URL,
    MYPROFILE_BROKER_ROBO_URL,
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    PORTFOLIO_TRACKING_URL,
    PROC_RA_ASSOCIATIVE_OBJECTIVE,
    PROC_RA_ASSOCIATIVE_OBJECTIVE_ASSOCIATE_BUTTON,
    PROC_RA_ASSOCIATIVE_OBJECTIVE_MODIFY_OBJECT_NAME,
    RA_DATEPICKER_MAXIMUM_YEARS,
    RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT,
    RA_PROJECTION_CHART_ALL_PRODUCTS,
    STRATEGY_TRACKING_URL,
    TIME_HORIZON_CHECK_ERROR,
    TIME_HORIZON_CHECK_WARNING,
    CONTRIBUTION_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
} = require('../../raConstants/index');

const {
    TRANSFER_SEPA_NATIONAL_PERIODICITY_ID,
} = require('constants/operationTypes');

const {
    DATE_PICKER_CUSTOM_DATE_FORMAT,
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_LOCALE,
} = require('constants/commonsComponents');

const headerIcons = {
    1: 'icon-KualaLumpur-small',
    2: 'icon-shangai-small',
    3: 'icon-taipei-small', // @TODO: test it when ezequiel upload icon-fonts
    4: 'icon-NewYork-small',
    5: 'icon-dubai-small',
};

const raContributionPeriodicity = {
    [CONTRIBUTION_PERIOD_DAILY]: formatText('raContributionPeriodicity-daily'),
    [CONTRIBUTION_PERIOD_WEEKLY]: formatText(
        'raContributionPeriodicity-weekly',
    ),
    [CONTRIBUTION_PERIOD_MONTHLY]: formatText(
        'raContributionPeriodicity-monthly',
    ),
};

class RAAssociateObjectiveView extends React.Component {
    constructor(props) {
        super(props);

        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleEndDateError = this.handleEndDateError.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleGetImageClicked = this.handleGetImageClicked.bind(this);
        this.handleRecurringContributionChange = this.handleRecurringContributionChange.bind(
            this,
        );
        this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
        this.handleContributionDayChange = this.handleContributionDayChange.bind(
            this,
        );
        this.handleAssociateObjective = this.handleAssociateObjective.bind(
            this,
        );
        this.handleFinish = this.handleFinish.bind(this);
        this.handleStockContractChange = this.handleStockContractChange.bind(
            this,
        );
        this.handleResetClick = this.handleResetClick.bind(this);
    }

    componentDidMount() {
        const {
            fetchMyInvestments,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
            getCGDAccountNumberVal,
            setMaxTypeOfProduct,
        } = this.props;

        getCGDAccountNumberVal(portfolioId);

        if (!immGlobalPosition.get('hasRoboHired')) {
            fetchMyInvestments().then(() => {
                this.getPrefilledData();
                setMaxTypeOfProduct(portfolioId);
            });
        } else {
            this.getPrefilledData();
            setMaxTypeOfProduct(portfolioId);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    getPrefilledData() {
        const {
            immAccounts,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const immPortfolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        const portfolioName = immPortfolio.get('name');
        const recurringContributionAmount = immPortfolio.getIn([
            'recurringTransfers',
            'amount',
        ]);
        const code = immPortfolio.getIn([
            'recurringTransfers',
            'recurringCode',
        ]);
        const nextDate = immPortfolio.getIn([
            'recurringTransfers',
            'nextTransferDate',
        ]);
        const contributionDay = getDay(nextDate);
        const accountContract = immPortfolio.getIn([
            'recurringTransfers',
            'originalAccount',
            'contrato',
        ]);
        const stockContractOptions = buildAccountsDropdownOptions(immAccounts);
        const filteredAccount = stockContractOptions.filter(
            account =>
                account.newWalletNumber === accountContract ||
                account.walletNumber === accountContract,
        );
        const selectedAccountId = filteredAccount.keys().next().value;

        if (recurringContributionAmount > 0) {
            this.props.setFormValues(
                'recurringContributionAmount',
                recurringContributionAmount,
            );
            this.props.setFormValues('contributionDay', contributionDay);
            this.props.setFormValues('periodicity', code);
            this.props.setFormValues('prefilledData', true);
            this.props.setFormValues('portfolioName', portfolioName);
            this.props.setSelectedAccount(selectedAccountId);
        }
    }

    buildAmountSection() {
        const { immRAAssociateObjective } = this.props;
        const goalAmount = immRAAssociateObjective.get('goalAmount');
        const goalAmountError = immRAAssociateObjective.get('goalAmountError');
        const injectedStrings = [MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT];

        return (
            <div className="ra-associate-objective-view__section-amount">
                <AmountInput
                    amount={goalAmount}
                    callback={this.handleAmountChange} // eslint-disable-line
                    max={RA_SET_GOAL_MAXIMUM_INVESTMENT_AMOUNT}
                    label={formatText('raSetGoal-goalAmountTitle')}
                    language={getLanguage()}
                    hideFocusZero={true}
                    error={goalAmountError}
                    errorMsg={formatText(
                        'rainput-amoutInputMinimumValidation',
                        injectedStrings,
                    )}
                />
                <span className="ra-associate-objective-view__currency">
                    {EURO_SYMBOL}
                </span>
            </div>
        );
    }

    buildImageButtons() {
        const goalSelected = this.props.immRAAssociateObjective.getIn([
            'selectedGoalDetail',
            'id',
        ]);
        const goalsList = this.props.immSetGoal.getIn([
            'steps',
            FIRST_STEP,
            'goals',
        ]);
        const immSteps = this.props.immSetGoal.get('steps');
        const validStep = immSteps.getIn([FIRST_STEP, 'goalSelected']);
        let extraClassForGoalWrapper;

        const content = goalsList.map((goal, index) => {
            const titleKey = goal.get('title');
            const title = formatText(titleKey);
            const goalId = goal.get('id');
            const isSelected = goalId === goalSelected;
            const id = goalId;
            const extraClass = isSelected
                ? 'ra-associate-objective-view__select-goal-icon'
                : '';

            if (!validStep) {
                extraClassForGoalWrapper = 'ra-image-button__initial-state';
            }

            return (
                <RAImageButton
                    label={title}
                    iconType={id}
                    extraClass={extraClass}
                    extraClassForGoalWrapper={extraClassForGoalWrapper}
                    id={id}
                    key={title + `-` + index}
                    isSelected={isSelected}
                    size="medium"
                />
            );
        });

        return content;
    }

    buildCustomCalender() {
        const { immRAAssociateObjective, immTimeHorizonCheck } = this.props;
        let investmentDate = immRAAssociateObjective.get('investmentDate');
        const dateLabel = formatText('raSetGoal-calenderText');
        const minDate = moment()
            .startOf('day')
            .add(1, 'day')
            .add(1, 'years');
        const maxDate = moment()
            .startOf('day')
            .add(RA_DATEPICKER_MAXIMUM_YEARS, 'years');
        const timeHorizonErrorState =
            immTimeHorizonCheck.get('status') === TIME_HORIZON_CHECK_ERROR ||
            immTimeHorizonCheck.get('status') === TIME_HORIZON_CHECK_WARNING;

        return (
            <div className="ra-associate-objective-view__section-invest-calendar">
                <div className="ra-associate-objective-view__section-invest-calendar-label">
                    {dateLabel}
                </div>
                <div key={investmentDate === null}>
                    <OKDatePicker
                        locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                        callback={this.handleDateChange} // eslint-disable-line
                        callbackError={this.handleEndDateError} // eslint-disable-line
                        selectedDate={investmentDate}
                        newSelectedDate={investmentDate}
                        placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        errorState={timeHorizonErrorState}
                        startDate={minDate}
                        minDate={minDate}
                        maxDate={maxDate}
                        messageStandardErrorDate={formatText(
                            'raDatePicker-raDatePicker_standardDateError',
                        )}
                        messageLessThanMinDateError={formatText(
                            'raDatePicker-raDatePicker_lessThanMinDateError',
                        )}
                        messageMoreThanMinDateError={formatText(
                            'raDatePicker-raDatePicker_moreThanMaxDateError',
                        )}
                        defaultPlaceholder={formatText(
                            'datePickerCustom-defaultPlaceholder',
                        )}
                        defaultPlaceholderDay={formatText(
                            'datePickerCustom-defaultPlaceholderDay',
                        )}
                        defaultPlaceholderMonth={formatText(
                            'datePickerCustom-defaultPlaceholderMonth',
                        )}
                        defaultPlaceholderYear={formatText(
                            'datePickerCustom-defaultPlaceholderYear',
                        )}
                    />
                </div>
            </div>
        );
    }

    buildContributionPeriodicity() {
        const { immRAAssociateObjective } = this.props;
        const recurringContributionAmount = immRAAssociateObjective.get(
            'recurringContributionAmount',
        );
        const contributionDay = immRAAssociateObjective.get('contributionDay');
        const periodicity = immRAAssociateObjective.get('periodicity');
        const errorPeriodicityMin = immRAAssociateObjective.get(
            'errorPeriodicityMin',
        );
        const prefilledData = immRAAssociateObjective.get('prefilledData');
        const disableSelect = recurringContributionAmount < 1 || prefilledData;

        return (
            <div className="ra-associate-objective-view__contribution-periodicity">
                <div className="ra-associate-objective-view__contribution-info">
                    <FormattedText
                        className="ra-associate-objective-view__primary-info"
                        value="raAssociateObjective-raAssociateObjective_addObjectivePeriodicityTitlte"
                    />
                    <FormattedText
                        className="ra-associate-objective-view__secondary-info"
                        value="raAssociateObjective-raAssociateObjective_addObjectivePeriodicitySubtitle"
                    />
                </div>
                <RAContributionPeriodicity
                    disabled={prefilledData}
                    amount={recurringContributionAmount}
                    selectedDay={contributionDay}
                    selectedPeriodicity={periodicity}
                    onDayClick={this.handleContributionDayChange}
                    onPeriodicityChange={this.handlePeriodicityChange}
                    onRecurringContributionChange={
                        this.handleRecurringContributionChange
                    }
                    errorState={errorPeriodicityMin}
                    errorMessage={formatText(
                        'raHireManagementPlanStep2-errorMessage',
                    )}
                    keepZeroAndEmpty={true}
                    disableSelect={disableSelect}
                    hideFocusZero={true}
                    allowPunctual={prefilledData}
                />
            </div>
        );
    }

    buildSelectAccountSection() {
        const { immAccounts, immRAAssociateObjective } = this.props;
        const stockContractOptions = buildAccountsDropdownOptions(immAccounts);
        const prefilledData = immRAAssociateObjective.get('prefilledData');
        const selectedAccountError = immRAAssociateObjective.get(
            'selectedAccountError',
        );

        return (
            <div className="ra-associate-objective-view__contribution-periodicity">
                <div className="ra-associate-objective-view__info">
                    <FormattedText
                        className="ra-associate-objective-view__primary-info"
                        value="raAssociateObjective-raAssociateObjective_addObjectiveAccountSelectionTitle"
                    />
                </div>
                <StocksContractDropdown
                    disabled={prefilledData}
                    errorMessage={formatText(
                        'raHireManagementPlanStep2-accountErrorMessage',
                    )}
                    errorState={selectedAccountError}
                    label="raAssociateObjective-raAssociateObjective_selectAccountLabelNew"
                    modifier={
                        BROKER_STOCKS_CONTRACT_DROPDOWN_DERIVATIVES_TRANSFER_MODIFIER
                    }
                    onStockContractChange={this.handleStockContractChange}
                    options={stockContractOptions.toArray()}
                    placeholder={formatText('transfers-selectAccount')}
                    selectedValue={immRAAssociateObjective.get(
                        'selectedAccountId',
                    )}
                />
            </div>
        );
    }

    buildGoalSelectionSection() {
        const content = this.buildImageButtons();

        return (
            <RAImageButtonGroup
                onChange={this.handleGetImageClicked}
                extraClass="ra-associate-objective-view__image-button-group"
            >
                {content}
            </RAImageButtonGroup>
        );
    }

    buildInvestmentSectionBlock() {
        const { immRAAssociateObjective } = this.props;
        const investmentTitle = immRAAssociateObjective.get('investmentTitle');
        const selectedGoal = immRAAssociateObjective.getIn([
            'selectedGoalDetail',
            'id',
        ]);
        const extraContent = !selectedGoal ? (
            <i className="icon-nuevos-objetivos icon ra-set-goal-step2__goal-icon" />
        ) : null;
        const amountSectionBlock = this.buildAmountSection();
        const calenderSectionBlock = this.buildCustomCalender();

        return (
            <div className="ra-associate-objective-view__section-invest">
                <RAImageButton
                    extraClass="ra-set-goal-step2__section-invest--goal-icon"
                    extraContent={extraContent}
                    iconType={selectedGoal}
                    isSelected={true}
                    size="small"
                    extraClassForGoalWrapper="ra-associate-objective-view__section-invest--goal-icon"
                />
                <div className="ra-associate-objective-view__section-invest--goal-value ra-associate-objective-view__placeholder">
                    <h1 className="profile-picture-editor__alias-edit">
                        <BrokerEditAlias
                            alias={investmentTitle}
                            postAlias={this.handleTitleChange} // eslint-disable-line
                            fontSize={BROKER_ROBO_EDIT_FIELD_FONT}
                        />
                    </h1>
                </div>
                {amountSectionBlock}
                {calenderSectionBlock}
            </div>
        );
    }

    buildStrategyGraph() {
        const {
            immRAAssociateObjective,
            immExpectedProfitability,
            immTimeHorizonCheck,
            immGlobalPosition,
            immProfile,
            immSuitabilityTest,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const goalAmount = immRAAssociateObjective.get('goalAmount');
        const investmentAmountError = immRAAssociateObjective.get(
            'investmentAmountError',
        );
        const investmentDate = immRAAssociateObjective.get('investmentDate');
        const immPortfolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        const currentValuation = immPortfolio.getIn([
            'keyFigures',
            'valuation',
        ]);
        const selectedStrategy = immPortfolio.getIn([
            'product',
            'typeOfProduct',
        ]);
        const strategyName = formatText(
            `raStrategyItem-raStrategyItem_${selectedStrategy}`,
        );
        const maxInvestmentProfile = immSuitabilityTest.getIn(
            ['results', 0, 'maxTypeOfProduct'],
            0,
        );

        return (
            goalAmount > 0 &&
            !investmentAmountError && (
                <div className="ra-associate-objective-view__strategy-graph">
                    <div className="ra-associate-objective-view__strategy-header">
                        <FormattedText
                            value="raAssociateObjective-raAssociateObjective_strategyGraphHeader"
                            className="ra-management-plan-view__accordion-header"
                            injectedStrings={[strategyName]}
                        />
                    </div>
                    <RAStrategiesGraph
                        goal={goalAmount}
                        immExpectedProfitability={immExpectedProfitability}
                        initialContributionAmount={currentValuation}
                        currentValuationKey="raAssociateObjective-raAssociateObjective_goalValuationLabel"
                        objectiveEndDate={investmentDate}
                        maxAvailableInvestmentProfile={immTimeHorizonCheck.get(
                            'maxTypeOfProduct',
                        )}
                        maxInvestmentProfile={maxInvestmentProfile}
                        selectedStrategy={selectedStrategy}
                        singleStrategy={true}
                        showDescription={true}
                        showLegalText={true}
                        userName={immProfile.get('nombreCompleto')}
                    />
                </div>
            )
        );
    }

    getBreadcrumb() {
        const {
            match: {
                params: { portfolioId },
            },
        } = this.props;
        return [
            {
                text: formatText(
                    'raPortfolioTracking-raPortfolioTracking_breadcrumbFirst',
                ),
                url: BROKER_PG_URL,
            },
            {
                text: formatText(
                    'raPortfolioTracking-raPortfolioTracking_breadcrumbSecond',
                ),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText(
                    'raPortfolioTracking-raPortfolioTracking_breadcrumbThird',
                ),
                url: `${PORTFOLIO_TRACKING_URL}/${portfolioId}`,
            },
            {
                text: formatText('breadcrumb-breadcrumb_addObjective'),
            },
        ];
    }

    handleGetImageClicked(goalSelected) {
        const { updateGoalSelected } = this.props;
        this.props.setFormValues('investmentTitle', goalSelected.label);
        updateGoalSelected(goalSelected);
    }

    getProductIcon() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const immPortfolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        const product = immPortfolio.getIn(['product', 'typeOfProduct']);
        if (!product) {
            return false;
        }
        const iconTitleClass = `ra-portfolio-tracking-view__product-icon ${headerIcons[product]}`;

        return <i className={iconTitleClass} />;
    }

    handleAmountChange(value) {
        this.props.setFormValues('goalAmount', value);
        this.requestBarChart({});
    }

    timeHorizonCheck(date) {
        this.props.setTimeHorizonCheck(date);
        this.props.timeHorizonCheck();
    }

    handleDateChange(value) {
        const objectiveEndDate = value.format(DATE_FORMAT_API);
        this.props.setFormValues('investmentDate', objectiveEndDate);
        this.timeHorizonCheck(objectiveEndDate);
        this.requestBarChart({ objectiveEndDate });
    }

    handleEndDateError() {
        const { immCustomPlanByObjective } = this.props;
        if (!immCustomPlanByObjective.get('objectiveEndDateError')) {
            this.props.setObjectiveEndDateError();
        }
    }

    handleTitleChange(value) {
        recordLink(
            PROC_RA_ASSOCIATIVE_OBJECTIVE,
            PROC_RA_ASSOCIATIVE_OBJECTIVE_MODIFY_OBJECT_NAME,
        );
        this.props.setFormValues('investmentTitle', value);
    }

    handleRecurringContributionChange(value) {
        this.props.setFormValues('recurringContributionAmount', value);
        this.requestBarChart({ recurringContributionAmount: value });
    }

    handlePeriodicityChange(ev) {
        const periodicity = ev.value;
        this.props.setFormValues('periodicity', periodicity);
        this.requestBarChart({ periodicity });
    }

    handleContributionDayChange(ev) {
        const contributionDay = parseInt(ev.currentTarget.dataset.id);
        this.props.setFormValues('contributionDay', contributionDay);
        this.requestBarChart({ contributionDay });
    }

    handleAssociateObjective() {
        const {
            initAddObjective,
            history,
            match: {
                params: { portfolioId },
            },
            immRAAssociateObjective,
        } = this.props;
        recordLink(
            PROC_RA_ASSOCIATIVE_OBJECTIVE,
            PROC_RA_ASSOCIATIVE_OBJECTIVE_ASSOCIATE_BUTTON,
        );
        immRAAssociateObjective.get('immRAAssociateObjective');
        initAddObjective(portfolioId, history);
    }

    handleFinish() {
        const {
            history,
            signatureFinish,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        signatureFinish(history, portfolioId);
    }

    handleStockContractChange(selectedAccountId) {
        const { immAccounts, setSelectedAccount } = this.props;
        const accountBalance = immAccounts.getIn([
            'byId',
            selectedAccountId,
            'balances',
            'availableBalance',
            'amount',
        ]);
        setSelectedAccount(selectedAccountId, accountBalance);
    }

    handleResetClick() {
        const { reset, resetMaxTypeOfProduct } = this.props;
        resetMaxTypeOfProduct();
        reset();
    }

    buildResetButton() {
        return (
            <div className="ra-associate-objective-view__header-button-right">
                <OKButton
                    modifier="ghost"
                    size="small"
                    leftIcon="icon-limpiar_objetivo"
                    onClick={this.handleResetClick}
                >
                    <FormattedText value="raGlobal-raGlobal_resetGoalButton" />
                </OKButton>
            </div>
        );
    }

    createListItems(className, listItemsArray) {
        return listItemsArray.map((listItem, index) => (
            <li key={index} className={className}>
                <FormattedText
                    value={listItem.value}
                    injectedStrings={[listItem.injectedStrings]}
                />
            </li>
        ));
    }

    fetchValues() {
        const {
            immAccounts,
            immProfile,
            immGlobalPosition,
            immRAAssociateObjective,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const userName = immProfile.get('nombreCompleto');
        const product = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'product',
            'typeOfProduct',
        ]);
        const portfolioName = formatText(
            `raStrategyItem-raStrategyItem_${product}`,
        );
        const objectiveName = immRAAssociateObjective.getIn([
            'selectedGoalDetail',
            'label',
        ]);
        const objectiveTitle = immRAAssociateObjective.get('investmentTitle');
        const goalAmount = immRAAssociateObjective.get('goalAmount');
        const goalAmountFormatted = CurrencyHelper.getFormattedString({
            amount: goalAmount,
            currency: EURO_SYMBOL,
        });
        const investmentDate = immRAAssociateObjective.get('investmentDate');
        const goalEndDate = formatText(
            'raStrategiesGraph-raStrategiesGraph_endDateCustom',
            [
                getDay(investmentDate),
                toFirstUppercase(getMonthNameFromDate(investmentDate)),
                getFullYear(investmentDate),
            ],
        );
        const selectedAccountId = immRAAssociateObjective.get(
            'selectedAccountId',
        );
        const fullContractNumber = immAccounts.getIn([
            'byId',
            selectedAccountId,
            'oldFullContractNumber',
        ]);
        const periodicity = immRAAssociateObjective.get('periodicity');
        const raContributionPeriodicityName =
            raContributionPeriodicity[periodicity];
        const contributionDay = immRAAssociateObjective.get('contributionDay');
        const investmentAmountError = immRAAssociateObjective.get(
            'investmentAmountError',
        );
        const prefilledData = immRAAssociateObjective.get('prefilledData');
        const recurringContributionAmount = immRAAssociateObjective.get(
            'recurringContributionAmount',
        );
        const recurringContributionAmountFormatted = CurrencyHelper.getFormattedString(
            {
                amount: recurringContributionAmount,
                currency: EURO_SYMBOL,
            },
        );
        const showSignaturePattern = immRAAssociateObjective.get(
            'showSignaturePattern',
        );
        return {
            objectiveName,
            objectiveTitle,
            goalAmount,
            goalAmountFormatted,
            goalEndDate,
            recurringContributionAmountFormatted,
            raContributionPeriodicityName,
            contributionDay,
            fullContractNumber,
            portfolioName,
            userName,
            investmentAmountError,
            prefilledData,
            selectedAccountId,
            recurringContributionAmount,
            showSignaturePattern,
        };
    }

    buildPrintPriviewContent() {
        const {
            objectiveName,
            objectiveTitle,
            goalAmountFormatted,
            goalEndDate,
            recurringContributionAmountFormatted,
            raContributionPeriodicityName,
            contributionDay,
            fullContractNumber,
            portfolioName,
            userName,
            showSignaturePattern,
        } = this.fetchValues();

        const objectiveDetailsList = [
            {
                value:
                    'raAssociateObjective-raAssociateObjective_printCCList1Item1',
                injectedStrings: [objectiveName],
            },
            {
                value:
                    'raAssociateObjective-raAssociateObjective_printCCList1Item2',
                injectedStrings: [objectiveTitle],
            },
            {
                value:
                    'raAssociateObjective-raAssociateObjective_printCCList1Item3',
                injectedStrings: [goalAmountFormatted],
            },
            {
                value:
                    'raAssociateObjective-raAssociateObjective_printCCList1Item4',
                injectedStrings: [goalEndDate],
            },
        ];
        const contributionDetailsList = [
            {
                value:
                    'raAssociateObjective-raAssociateObjective_printCCList2Item1',
                injectedStrings: [recurringContributionAmountFormatted],
            },
            {
                value:
                    'raAssociateObjective-raAssociateObjective_printCCList2Item2',
                injectedStrings: [raContributionPeriodicityName],
            },
            {
                value:
                    'raAssociateObjective-raAssociateObjective_printCCList2Item3',
                injectedStrings: [contributionDay],
            },
            {
                value:
                    'raAssociateObjective-raAssociateObjective_printCCList2Item4',
                injectedStrings: [fullContractNumber],
            },
        ];

        const objectiveDetailsListItems = this.createListItems(
            'ra-associate-objective-view__print-child-list-item',
            objectiveDetailsList,
        );
        const contributionDetailsListItems = this.createListItems(
            'ra-associate-objective-view__print-child-list-item',
            contributionDetailsList,
        );

        const contributionDetailsListComponent = showSignaturePattern && (
            <li className="ra-associate-objective-view__print-list1-item">
                <FormattedText
                    className="ra-associate-objective-view__print-child-list-title"
                    value="raAssociateObjective-raAssociateObjective_printCCList2Title"
                />
                <ul className="ra-associate-objective-view__print-child-list">
                    {contributionDetailsListItems}
                </ul>
            </li>
        );

        return (
            <div
                id="printable-wizard"
                className="ra-associate-objective-view__print"
            >
                <h2 className="ra-associate-objective-view__print-heading">
                    <FormattedText
                        value="raAssociateObjective-raAssociateObjective_printCCTitle"
                        injectedStrings={[portfolioName]}
                    />
                </h2>
                <FormattedText
                    className="ra-associate-objective-view__print-subtitle"
                    value="raAssociateObjective-raAssociateObjective_printCCSubtitle"
                    injectedStrings={[userName, portfolioName]}
                />
                <ul className="ra-associate-objective-view__print-parent-list">
                    <li className="ra-associate-objective-view__print-parent-list-item">
                        <FormattedText
                            className="ra-associate-objective-view__print-child-list-title"
                            value="raAssociateObjective-raAssociateObjective_printCCList1Title"
                        />
                        <ul className="ra-associate-objective-view__print-child-list">
                            {objectiveDetailsListItems}
                        </ul>
                    </li>
                    {contributionDetailsListComponent}
                </ul>
            </div>
        );
    }

    buildSignaturePatternComponent() {
        const {
            immSignaturePattern,
            immRAAssociateObjective,
            immAccounts,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const amount = immRAAssociateObjective.get(
            'recurringContributionAmount',
        );
        const selectedAcountId = immRAAssociateObjective.get(
            'selectedAccountId',
        );
        const immAccount = immAccounts.getIn(['byId', selectedAcountId]);
        const originAccount = `${API_ENTERPRISE_NUMBER}${API_CENTER}${immAccount.get(
            'newProduct',
        )}${immAccount.get('newContractNumber')}`;
        const isFetchingSMSCode = immSignaturePattern.get('isFetchingSMSCode');

        const destinationAccount =
            immGlobalPosition.getIn([
                'roboAccount',
                portfolioId,
                'ibanComplex',
                'pais',
            ]) +
            immGlobalPosition.getIn([
                'roboAccount',
                portfolioId,
                'ibanComplex',
                'digitodecontrol',
            ]) +
            immGlobalPosition.getIn([
                'roboAccount',
                portfolioId,
                'ibanComplex',
                'codbban',
            ]);

        const operationType = TRANSFER_SEPA_NATIONAL_PERIODICITY_ID;
        const operationParams = {
            ammount: amount,
            currency: EURO_TEXT,
            originAccount,
            destinationAccount,
        };

        return (
            <React.Fragment>
                <div className="ra-associate-objective-view__signature-pattern">
                    <FormattedText
                        className="ra-associate-objective-view__primary-info"
                        value="raAssociateObjective-raAssociateObjective_addObjectiveSignatureTitle"
                    />
                    <SignaturePattern
                        operationType={operationType}
                        operationParams={operationParams}
                        displayTitle={false}
                        isInVerticalWizard={true}
                    />
                </div>
                <OKMessage type="informative" modifier="dark-bg">
                    <FormattedText value="raAssociateObjective-raAssociateObjective_assocaiteObjectiveInfoText" />
                </OKMessage>
                <div className="ra-associate-objective-view__footer-buttons">
                    <RAFooter
                        cancelPath={GO_BACK_URL}
                        loading={isFetchingSMSCode}
                        rightButtonText={formatText(
                            'raAssociateObjective-raAssociateObjective_ctaConfirm',
                        )}
                        showRightContent={true}
                        onRightButtonClick={this.handleFinish}
                        includePrintPreviewManagerButton={true}
                    />
                </div>
            </React.Fragment>
        );
    }

    buildListItems(listItemsArray) {
        return listItemsArray.map((item, index) => {
            const itemValue = hasTranslation(
                `cc_raAssociateObjective-${item.value}`,
            )
                ? formatText(
                      `cc_raAssociateObjective-${item.value}`,
                      item.injectedStrings,
                  )
                : item.value;

            return (
                <li
                    key={index}
                    className="ra-associate-objective-view__informative-item"
                >
                    <FormattedText
                        className="ra-associate-objective-view__informative-item-tile"
                        value={`cc_raAssociateObjective-${item.title}`}
                    />
                    <span className="ra-associate-objective-view__informative-item-value">
                        {itemValue}
                    </span>
                </li>
            );
        });
    }

    buildObjectiveInfoSummaryLegalText() {
        const {
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const {
            goalAmountFormatted,
            goalEndDate,
            objectiveName,
            objectiveTitle,
        } = this.fetchValues();
        const currentValuation = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
            'keyFigures',
            'valuation',
        ]);
        const currentValuationFormatted = CurrencyHelper.getFormattedString({
            amount: currentValuation,
            currency: EURO_SYMBOL,
        });
        const objectiveInfoItemArray = [
            { title: 'objectiveTypeTitle', value: objectiveName },
            { title: 'objectiveNameTitle', value: objectiveTitle },
            { title: 'objectiveAmountTitle', value: goalAmountFormatted },
            {
                title: 'objectiveInitialInvestmentTitle',
                value: currentValuationFormatted,
            },
            { title: 'objectiveDateTitle', value: goalEndDate },
        ];
        const objectiveInfoItems = this.buildListItems(objectiveInfoItemArray);

        return (
            <ul className="ra-associate-objective-view__informative-list">
                {objectiveInfoItems}
            </ul>
        );
    }

    buildPeriodicContributionInfoSummaryLegalText() {
        const {
            recurringContributionAmountFormatted,
            raContributionPeriodicityName,
            contributionDay,
            fullContractNumber,
        } = this.fetchValues();
        const periodicContributionItemArray = [
            {
                title: 'periodicContributionAmountTitle',
                value: recurringContributionAmountFormatted,
            },
            {
                title: 'periodicContributionTypeTitle',
                value: raContributionPeriodicityName,
            },
            {
                title: 'periodicContributionDayTitle',
                value: 'periodicContributionDayValue',
                injectedStrings: [contributionDay],
            },
            {
                title: 'periodicContributionCurrentAccountTitle',
                value: fullContractNumber,
            },
        ];
        const periodicContributionInfoItems = this.buildListItems(
            periodicContributionItemArray,
        );

        return (
            <ul className="ra-associate-objective-view__informative-list">
                {periodicContributionInfoItems}
            </ul>
        );
    }

    buildOperationSummaryLegalTextSection() {
        const {
            portfolioName,
            userName,
            recurringContributionAmount,
            selectedAccountId,
            prefilledData,
            investmentAmountError,
            goalAmount,
        } = this.fetchValues();

        const objectiveInfo = this.buildObjectiveInfoSummaryLegalText();
        let perodicContributionText;
        if (
            recurringContributionAmount > 0 &&
            !!selectedAccountId &&
            !prefilledData
        ) {
            const periodicContributionInfo = this.buildPeriodicContributionInfoSummaryLegalText();
            perodicContributionText = (
                <React.Fragment>
                    <FormattedText
                        className="ra-associate-objective-view__block-info-text"
                        value="cc_raAssociateObjective-periodicContributionInfoTitle"
                    />
                    {periodicContributionInfo}
                </React.Fragment>
            );
        }

        return (
            goalAmount > 0 &&
            !investmentAmountError && (
                <ContactCenterRender>
                    <div className="ra-associate-objective-view__operation-summary-wrapper">
                        <h2 className="ra-associate-objective-view__operation-summary-title">
                            <FormattedText
                                className="ra-associate-objective-view__primary-info"
                                value="raAssociateObjective-raAssociateObjective_legalSummarySectionTitle"
                            />
                        </h2>
                        <BlockInfo extraClass="ra-associate-objective-view__block-info">
                            <FormattedText
                                className="ra-associate-objective-view__block-info-title"
                                value="raStrategiesGraph-raStrategiesGraph_legalTextTitle"
                            />
                            <FormattedText
                                className="ra-associate-objective-view__block-info-text"
                                value="raAssociateObjective-raAssociateObjective_legalText1"
                                injectedStrings={[userName, portfolioName]}
                            />
                            <FormattedText
                                className="ra-associate-objective-view__block-info-text"
                                value="cc_raAssociateObjective-objectiveInfoListTitle"
                            />
                            {objectiveInfo}
                            {perodicContributionText}
                            <FormattedText
                                className="ra-associate-objective-view__block-info-text"
                                value="raAssociateObjective-raAssociateObjective_legalText4"
                                injectedStrings={[userName]}
                            />
                        </BlockInfo>
                    </div>
                </ContactCenterRender>
            )
        );
    }

    requestBarChart({
        objectiveEndDate,
        periodicity,
        recurringContributionAmount,
        contributionDay,
    }) {
        const {
            requestProjectionChart,
            immRAAssociateObjective,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;

        objectiveEndDate =
            objectiveEndDate || immRAAssociateObjective.get('investmentDate');
        periodicity = periodicity || immRAAssociateObjective.get('periodicity');
        recurringContributionAmount =
            recurringContributionAmount ||
            immRAAssociateObjective.get('recurringContributionAmount');
        contributionDay =
            contributionDay || immRAAssociateObjective.get('contributionDay');
        const immPortfolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        const valuation = immPortfolio.getIn(['keyFigures', 'valuation']);
        const nDays = Math.abs(getNumOfDaysBetweenDates(objectiveEndDate));
        const chartYears = nDays / 365;
        const freq = periodicity || 1;

        if (
            recurringContributionAmount >= 1 &&
            freq === CONTRIBUTION_PERIOD_MONTHLY
        ) {
            requestProjectionChart({
                dataPoints: 2,
                chartYears,
                product: RA_PROJECTION_CHART_ALL_PRODUCTS,
                balance: valuation,
                freq,
                mntPayment: recurringContributionAmount,
                cutDay: contributionDay,
            });
        } else {
            requestProjectionChart({
                dataPoints: 2,
                chartYears,
                product: RA_PROJECTION_CHART_ALL_PRODUCTS,
                balance: valuation,
                freq,
                mntPayment: recurringContributionAmount,
            });
        }
    }

    getGoalIconImage(goalType) {
        switch (goalType) {
            // @Temporally logic, TODO: change RACircularProgressIcon to implement as modifier class
            case 'CAR':
                return carImage;
            case 'TRAVEL':
                return travelImage;
            case 'HOME':
                return homeImage;
            case 'EDUCATION':
                return educationImage;
            case 'OTHERS':
                return otherImage;
            default:
                return '';
        }
    }

    getPortfolioIcon(productType) {
        const iconClassName = classNames(
            'ra-summary-widget__icon-product',
            `ra-summary-widget__icon-product--${productType}`,
        );
        return iconClassName;
    }

    buildSuccessScreenLegalTextSection() {
        return (
            <ContactCenterRender>
                <BlockInfo extraClass="ra-associate-objective-view__block-info">
                    <FormattedText
                        className="ra-associate-objective-view__block-info-title"
                        value="raStrategiesGraph-raStrategiesGraph_legalTextTitle"
                    />
                    <FormattedText
                        className="ra-associate-objective-view__block-info-text"
                        value="raAssociateObjective-raAssociateObjective_successlegalText1"
                    />
                    <FormattedText
                        className="ra-associate-objective-view__block-info-text"
                        value="raAssociateObjective-raAssociateObjective_successlegalText2"
                    />
                </BlockInfo>
            </ContactCenterRender>
        );
    }

    buildSuccessSection() {
        const {
            immRAAssociateObjective,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        const goalType = immRAAssociateObjective
            .getIn(['selectedGoalDetail', 'id'])
            .toUpperCase();
        const goalIcon = this.getGoalIconImage(goalType);
        const immPortfolio = immGlobalPosition.getIn([
            'portfolios',
            portfolioId,
        ]);
        const productType = immPortfolio.getIn(['product', 'typeOfProduct']);
        const productName = immRAAssociateObjective.get('portfolioName');
        const objectiveName = immRAAssociateObjective.get('investmentTitle');
        const periodicity = immRAAssociateObjective.get('periodicity');
        const recurringContributionAmount = immRAAssociateObjective.get(
            'recurringContributionAmount',
        );
        const goalAmount = immRAAssociateObjective.get('goalAmount');
        const investmentDate = immRAAssociateObjective.get('investmentDate');
        const contributionFailure = immRAAssociateObjective.get(
            'contributionFailure',
        );
        const productIcon = this.getPortfolioIcon(productType);
        const valuation = immPortfolio.getIn(['keyFigures', 'valuation']);
        const successScreenLegalTextSection = this.buildSuccessScreenLegalTextSection();

        return (
            <RAAssociateObjectiveSuccess
                goalIcon={goalIcon}
                productIcon={productIcon}
                productName={productName}
                name={objectiveName}
                periodicity={periodicity}
                goalAmount={goalAmount}
                goalType={goalType}
                goalEndOfDate={investmentDate}
                valuation={valuation}
                recurringContributionAmount={recurringContributionAmount}
                contributionFailure={contributionFailure}
                portfolioId={portfolioId}
            >
                {successScreenLegalTextSection}
            </RAAssociateObjectiveSuccess>
        );
    }

    buildAssociateObjectiveSection() {
        const { immRAAssociateObjective, immTimeHorizonCheck } = this.props;

        const goalSelectionSection = this.buildGoalSelectionSection();
        const investmentSectionBlock = this.buildInvestmentSectionBlock();
        const periodicContributionBlock = this.buildContributionPeriodicity();
        const selectAccountComponent = this.buildSelectAccountSection();
        const operationSummaryLegalTextSection = this.buildOperationSummaryLegalTextSection();
        const showSignaturePattern = immRAAssociateObjective.get(
            'showSignaturePattern',
        );
        const signaturePatternComponent =
            showSignaturePattern && this.buildSignaturePatternComponent();
        const printPriviewContent = this.buildPrintPriviewContent();
        const strategyGraph = this.buildStrategyGraph();
        const goalAmountError = immRAAssociateObjective.get('goalAmountError');
        const goalAmount = immRAAssociateObjective.get('goalAmount');
        const investmentDate = immRAAssociateObjective.get('investmentDate');
        const investmentDateError = immRAAssociateObjective.get(
            'investmentDateError',
        );
        const errorPeriodicityMin = immRAAssociateObjective.get(
            'errorPeriodicityMin',
        );
        const recurringContributionAmount = immRAAssociateObjective.get(
            'recurringContributionAmount',
        );
        const selectedAccountId = immRAAssociateObjective.get(
            'selectedAccountId',
        );
        const selectedAccountError = immRAAssociateObjective.get(
            'selectedAccountError',
        );
        const prefilledData = immRAAssociateObjective.get('prefilledData');
        const timeHorizonError =
            immTimeHorizonCheck.get('status') === TIME_HORIZON_CHECK_ERROR;
        const timeHorizonWarning =
            immTimeHorizonCheck.get('status') === TIME_HORIZON_CHECK_WARNING;
        const disableAddObjectiveButton =
            !goalAmount ||
            goalAmountError ||
            !investmentDate ||
            investmentDateError ||
            errorPeriodicityMin ||
            timeHorizonError ||
            timeHorizonWarning ||
            selectedAccountError ||
            showSignaturePattern ||
            (recurringContributionAmount >= 1 && !selectedAccountId);
        const goalSelectedId =
            immRAAssociateObjective.getIn(['selectedGoalDetail', 'id']) || '';
        const formSectionClasses = classNames(
            'ra-associate-objective-view__form-section',
            {
                'ra-associate-objective-view__form-section--disabled': !goalSelectedId,
            },
        );
        const resetButton = !!goalAmount ? this.buildResetButton() : null;

        const printWithPeriodic =
            !!selectedAccountId &&
            !selectedAccountError &&
            recurringContributionAmount >= 1 &&
            !prefilledData;
        const printerPreviewManager = !printWithPeriodic && (
            <PrinterPreviewManager />
        );
        const rightButton = (
            <OKButton
                onClick={this.handleAssociateObjective}
                modifier="secondary"
                disabled={disableAddObjectiveButton}
            >
                <FormattedText value="raAssociateObjective-raAssociateObjective_addObjectiveButton" />
            </OKButton>
        );

        return (
            <React.Fragment>
                <div className="ra-associate-objective-view__select-goal">
                    <h1 className="ra-associate-objective-view__select-goal-heading">
                        <FormattedText value="raAssociateObjective-raAssociateObjective_associateObjectiveHeader" />
                    </h1>
                    <p className="ra-associate-objective-view__select-goal-subtitle">
                        <FormattedText value="raAssociateObjective-raAssociateObjective_associateObjectiveText" />
                    </p>
                    {resetButton}
                    {goalSelectionSection}
                </div>
                <div className="ra-associate-objective-view__investment-wrapper">
                    <div className={formSectionClasses}>
                        {investmentSectionBlock}
                        <div className="ra-associate-objective-view__time-horizon-check">
                            <RATimeHorizonCheck alterWarningMessage={true} />
                        </div>
                        {periodicContributionBlock}
                        {selectAccountComponent}
                    </div>
                    <div className="ra-associate-objective-view__strategy-graph">
                        {strategyGraph}
                    </div>
                </div>
                {operationSummaryLegalTextSection}
                <div className="ra-associate-objective-view__ctabutton-container clearfix">
                    <span className="pull-left">{printerPreviewManager}</span>
                    <span className="pull-right">{rightButton}</span>
                </div>
                {signaturePatternComponent}
                {printPriviewContent}
            </React.Fragment>
        );
    }

    render() {
        const {
            immRAAssociateObjective,
            immBrokerMyInvestments,
            immAccountDetails,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
        } = this.props;
        let content;
        const mappingBreadcrumb = this.getBreadcrumb();
        const portfolioTrackingUrl = `${STRATEGY_TRACKING_URL}/${portfolioId}`;
        const submitSuccess = immRAAssociateObjective.get('submitSuccess');
        const successTitle =
            submitSuccess &&
            formatText(
                'raAssociateObjective-raAssociateObjective_associateObjectiveSuccessHeader',
            );
        let cgdNumber, subtitle;
        if (immAccountDetails) {
            cgdNumber = immAccountDetails.get('cgdNumber');
            if (cgdNumber && !submitSuccess) {
                subtitle = <RACgdNumber cgdNumberVal={cgdNumber} />;
            }
        }
        let rightContent = !submitSuccess && (
            <OKButton
                modifier="ghost"
                leftIcon="icon-anterior"
                inverse={true}
                to={portfolioTrackingUrl}
            >
                <FormattedText value="raAssociateObjective-raAssociateObjective_backButtonText" />
            </OKButton>
        );

        let coverTitleStatement, productIcon;

        if (immBrokerMyInvestments.get('isFetching')) {
            content = <LoadingSection />;
        } else if (submitSuccess) {
            content = this.buildSuccessSection();
        } else if (immBrokerMyInvestments.get('fetchSuccess')) {
            const immPortfolio = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
            ]);
            const coverTitle = immPortfolio.get('name');
            productIcon = !submitSuccess && this.getProductIcon();
            const injectedStrings = [coverTitle];
            coverTitleStatement = formatText(
                'raPortfolioDistributionWidget-raPortfolioDistributionWidget_cartera',
                injectedStrings,
            );
            content = this.buildAssociateObjectiveSection();
        }

        return (
            <div className="ra-associate-objective-view grid-view">
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={mappingBreadcrumb}
                            section="goal"
                            showHelp={false}
                            success={submitSuccess}
                            title={coverTitleStatement}
                            successTitle={successTitle}
                            rightContent={rightContent}
                            iconTitle={productIcon}
                            subtitle={subtitle}
                        />
                    </div>
                </div>
                <div className="ra-associate-objective-view__container">
                    <div className="grid-view__body">
                        <div className="container-fluid">{content}</div>
                    </div>
                </div>
            </div>
        );
    }
}

RAAssociateObjectiveView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountDetails: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immCustomPlanByObjective: PropTypes.object.isRequired,
    immExpectedProfitability: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immSetGoal: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    immTimeHorizonCheck: PropTypes.object.isRequired,
    immRAAssociateObjective: PropTypes.object.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    getCGDAccountNumberVal: PropTypes.func.isRequired,
    getTestResult: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    requestProjectionChart: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetMaxTypeOfProduct: PropTypes.func.isRequired,
    setMaxTypeOfProduct: PropTypes.func.isRequired,
    setTimeHorizonCheck: PropTypes.func.isRequired,
    timeHorizonCheck: PropTypes.func.isRequired,
    updateGoalSelected: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setFormValues: PropTypes.func.isRequired,
    setObjectiveEndDateError: PropTypes.func.isRequired,
    initAddObjective: PropTypes.func.isRequired,
    signatureFinish: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountDetails: state.raAccountDetails,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        immExpectedProfitability: state.raExpectedProfitability,
        immGlobalPosition: state.raGlobalPosition,
        immSetGoal: state.raSetGoal,
        immSuitabilityTest: state.raSuitabilityTest,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
        immRAAssociateObjective: state.raAssociateObjective,
        immSignaturePattern: state.signaturePattern,
        immProfile: state.profile,
    }),
    {
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        getCGDAccountNumberVal: raAccountDetailsActions.getCGDAccountNumber,
        requestProjectionChart:
            expectedProfitabilityActions.requestProjectionChart,
        resetMaxTypeOfProduct: raTimeHorizonCheckActions.resetMaxTypeOfProduct,
        setTimeHorizonCheck: raTimeHorizonCheckActions.setTimeHorizonCheck,
        timeHorizonCheck: raTimeHorizonCheckActions.timeHorizonCheck,
        updateGoalSelected: raSetGoalActions.updateGoalSelected,
        reset: raAssociateObjectiveActions.reset,
        setMaxTypeOfProduct: raAssociateObjectiveActions.setMaxTypeOfProduct,
        setSelectedAccount: raAssociateObjectiveActions.setSelectedAccount,
        setFormValues: raAssociateObjectiveActions.setFormValues,
        setObjectiveEndDateError:
            raCustomPlanByObjectiveActions.setObjectiveEndDateError,
        initAddObjective: raAssociateObjectiveActions.initAddObjective,
        signatureFinish: raAssociateObjectiveActions.signatureFinish,
    },
)(withRouter(RAAssociateObjectiveView));
